module.exports = __webpack_public_path__ + "static/media/Character-01.22cd88ea.png";